import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs';
import { DashboardRepository } from 'src/app/core/data/repository';
import { Bloc, ErrorState, InitEvent, ReadyState, ShowLoadingComponentState } from 'src/app/shared/bloc/base-bloc';
import { NonDrawing } from 'src/app/shared/model';

import { ContactUsMessagesEvent } from './contact-us-messages-event';
import { ContactUsMessagesState } from './contact-us-messages-state';

@Injectable()
export class ContactUsMessagesBloc extends Bloc<ContactUsMessagesEvent, ContactUsMessagesState> {
  constructor(public dashboardRepository: DashboardRepository) {
    super();
  }
  onIncomingEvents(event: ContactUsMessagesEvent): void {
    if (event instanceof InitEvent) {
      // loading component
      this.onState$.next(new ShowLoadingComponentState(true));
      // call api
      this.dashboardRepository
        .getContactUsMessages(event.args)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new ReadyState(result.data, result.count));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    }
  }
}
